import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API from "../config/API";

function UserLogin() {
  const navigate = useNavigate();

  // =====================================================
  // LOGIN FORM
  // =====================================================

  const [contactNo, setContactNo] = useState("");

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  // =====================================================
  // POPUP
  // =====================================================

  const [popup, setPopup] = useState({
    show: false,
    message: "",
    type: "",
  });

  // =====================================================
  // OTP POPUP
  // =====================================================

  const [otpPopup, setOtpPopup] = useState(false);

  const [otp, setOtp] = useState("");

  const [otpLoading, setOtpLoading] = useState(false);

  // =====================================================
  // LOGIN USER DETAILS
  // =====================================================

  const [loginUser, setLoginUser] = useState(null);

  // =====================================================
  // SHOW POPUP
  // =====================================================

  const showPopup = (message, type) => {
    setPopup({
      show: true,
      message,
      type,
    });

    setTimeout(() => {
      setPopup({
        show: false,
        message: "",
        type: "",
      });
    }, 3000);
  };

  // =====================================================
  // DEVICE TYPE
  // =====================================================

  const getDeviceType = () => {
    const userAgent = navigator.userAgent || "";

    if (/tablet|ipad|playbook|silk/i.test(userAgent)) {
      return "Tablet";
    }

    if (/android|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
      return "Mobile";
    }

    return "Desktop";
  };

  // =====================================================
  // OS NAME
  // =====================================================

  const getOSName = () => {
    const userAgent = navigator.userAgent || "";

    if (/Windows NT/i.test(userAgent)) {
      return "Windows";
    }

    if (/Android/i.test(userAgent)) {
      return "Android";
    }

    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      return "iOS";
    }

    if (/Mac OS X/i.test(userAgent)) {
      return "macOS";
    }

    if (/Linux/i.test(userAgent)) {
      return "Linux";
    }

    return "Unknown";
  };

  // =====================================================
  // BROWSER NAME
  // =====================================================

  const getBrowserName = () => {
    const userAgent = navigator.userAgent || "";

    if (/Edg\//i.test(userAgent)) {
      return "Microsoft Edge";
    }

    if (/OPR\//i.test(userAgent)) {
      return "Opera";
    }

    if (/Chrome\//i.test(userAgent) && !/Edg\//i.test(userAgent)) {
      return "Google Chrome";
    }

    if (/Firefox\//i.test(userAgent)) {
      return "Mozilla Firefox";
    }

    if (/Safari\//i.test(userAgent) && !/Chrome\//i.test(userAgent)) {
      return "Safari";
    }

    return "Unknown";
  };

  // =====================================================
  // BROWSER VERSION
  // =====================================================

  const getBrowserVersion = () => {
    const userAgent = navigator.userAgent || "";

    let match;

    // Microsoft Edge
    match = userAgent.match(/Edg\/([\d.]+)/i);

    if (match) {
      return match[1];
    }

    // Opera
    match = userAgent.match(/OPR\/([\d.]+)/i);

    if (match) {
      return match[1];
    }

    // Chrome
    match = userAgent.match(/Chrome\/([\d.]+)/i);

    if (match) {
      return match[1];
    }

    // Firefox
    match = userAgent.match(/Firefox\/([\d.]+)/i);

    if (match) {
      return match[1];
    }

    // Safari
    match = userAgent.match(/Version\/([\d.]+).*Safari/i);

    if (match) {
      return match[1];
    }

    return "Unknown";
  };

  // =====================================================
  // MOBILE NUMBER CHANGE
  // =====================================================

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 10);

    setContactNo(value);

    setError("");
  };

  // =====================================================
  // LOGIN
  // =====================================================

  const handleLogin = async (e) => {
    e.preventDefault();

    setError("");

    // -----------------------------------------------------
    // MOBILE VALIDATION
    // -----------------------------------------------------

    if (!contactNo) {
      setError("Mobile number is required.");
      return;
    }

    if (!/^[6-9]\d{9}$/.test(contactNo)) {
      setError("Enter a valid 10 digit mobile number.");
      return;
    }

    try {
      setLoading(true);

      // ---------------------------------------------------
      // DEVICE DETAILS
      // ---------------------------------------------------

      const deviceType = getDeviceType();

      const osName = getOSName();

      const browserName = getBrowserName();

      const browserVersion = getBrowserVersion();

      // ---------------------------------------------------
      // LOGIN PAYLOAD
      // ---------------------------------------------------

      const payload = {
        contactNo: contactNo,

        deviceType: deviceType,

        osName: osName,

        browserName: browserName,

        browserVersion: browserVersion,

        // Browser cannot access MAC address
        macId: null,
      };

      console.log("====================================");

      console.log("USER LOGIN PAYLOAD");

      console.log("====================================");

      console.log(payload);

      // ---------------------------------------------------
      // LOGIN API
      // ---------------------------------------------------

      const loginUrl = `${API.V2}/pgOwner/userLogin`;

      console.log("Login API:", loginUrl);

      const response = await axios.post(loginUrl, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("====================================");

      console.log("USER LOGIN RESPONSE");

      console.log("====================================");

      console.log(response.data);

      // ===================================================
      // LOGIN SUCCESS
      // ===================================================

      if (response.data?.statusCode === 200) {
        showPopup(
          response.data?.message || "OTP sent successfully.",
          "success",
        );

        // -------------------------------------------------
        // GET USER ID
        // -------------------------------------------------

        const userRegisterId =
          response.data?.customId || response.data?.data?.customId;

        console.log("User Register ID:", userRegisterId);

        // -------------------------------------------------
        // SAVE USER LOGIN DETAILS
        // -------------------------------------------------

        setLoginUser({
          userRegisterId: userRegisterId,

          contactNo: contactNo,
        });

        // -------------------------------------------------
        // CLEAR OTP
        // -------------------------------------------------

        setOtp("");

        // -------------------------------------------------
        // OPEN OTP POPUP
        // -------------------------------------------------

        setOtpPopup(true);
      } else {
        showPopup(response.data?.message || "Invalid mobile number.", "error");
      }
    } catch (error) {
      console.error("User Login Error:", error);

      console.error("Login Error Response:", error.response?.data);

      if (error.response) {
        showPopup(error.response?.data?.message || "Login failed.", "error");
      } else {
        showPopup("Server error. Please try again.", "error");
      }
    } finally {
      setLoading(false);
    }
  };

  // =====================================================
  // OTP CHANGE
  // =====================================================

  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);

    console.log("OTP entered:", value);

    setOtp(value);
  };

  // =====================================================
  // VERIFY OTP
  // =====================================================

  const handleVerifyOtp = async () => {
    console.log("========== VERIFY OTP BUTTON CLICKED ==========");

    // ---------------------------------------------------
    // OTP VALIDATION
    // ---------------------------------------------------

    if (!otp || otp.length !== 6) {
      showPopup("Please enter a valid 6 digit OTP.", "error");

      return;
    }

    // ---------------------------------------------------
    // USER VALIDATION
    // ---------------------------------------------------

    if (!loginUser?.userRegisterId) {
      console.log("Login User:", loginUser);

      showPopup("User login details not found.", "error");

      return;
    }

    try {
      setOtpLoading(true);

      // -------------------------------------------------
      // OTP PAYLOAD
      // -------------------------------------------------

      const payload = {
        customId: loginUser.userRegisterId,

        otp: otp,
      };

      console.log("====================================");

      console.log("VERIFY OTP PAYLOAD");

      console.log("====================================");

      console.log(payload);

      // -------------------------------------------------
      // VERIFY OTP API
      // -------------------------------------------------

      const verifyOtpUrl =
        "http://localhost:9777/v2/usersDashboard/verifyLoginOtp";

      console.log("Verify OTP API:", verifyOtpUrl);

      const response = await axios.post(verifyOtpUrl, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("====================================");

      console.log("VERIFY OTP RESPONSE");

      console.log("====================================");

      console.log(response.data);

      // =================================================
      // OTP SUCCESS
      // =================================================

      if (response.data?.statusCode === 200) {
        console.log("OTP verification successful");

        // ------------------------------------------------
        // SAVE USER REGISTER ID
        // ------------------------------------------------

        localStorage.setItem(
          "userRegisterId",
          String(loginUser.userRegisterId),
        );

        // ------------------------------------------------
        // SAVE CONTACT NUMBER
        // ------------------------------------------------

        localStorage.setItem("userContactNo", loginUser.contactNo);

        // ------------------------------------------------
        // GET JWT TOKEN
        // ------------------------------------------------

        const responseData = response.data?.data;

        const token =
          responseData?.token ||
          responseData?.jwtToken ||
          responseData?.accessToken;

        if (token) {
          console.log("JWT Token received");

          localStorage.setItem("userToken", token);

          localStorage.setItem("jwtToken", token);
        } else {
          console.log("No JWT token returned by API");
        }

        // ------------------------------------------------
        // SAVE COMPLETE LOGIN RESPONSE
        // ------------------------------------------------

        localStorage.setItem("userLogin", JSON.stringify(response.data));

        // ------------------------------------------------
        // CLOSE OTP POPUP
        // ------------------------------------------------

        setOtpPopup(false);

        setOtp("");

        // ------------------------------------------------
        // SUCCESS MESSAGE
        // ------------------------------------------------

        showPopup(
          response.data?.message ||
            "OTP verified successfully. Login successful.",
          "success",
        );

        // ------------------------------------------------
        // NAVIGATE DASHBOARD
        // ------------------------------------------------

        setTimeout(() => {
          navigate("/usersDashboardPage");
        }, 1500);
      } else {
        showPopup(response.data?.message || "Invalid OTP.", "error");
      }
    } catch (error) {
      console.error("OTP Verification Error:", error);

      console.error("OTP Error Response:", error.response?.data);

      showPopup(
        error.response?.data?.message || "Unable to verify OTP.",
        "error",
      );
    } finally {
      setOtpLoading(false);
    }
  };

  // =====================================================
  // CLOSE OTP
  // =====================================================

  const closeOtpPopup = () => {
    if (otpLoading) {
      return;
    }

    setOtpPopup(false);

    setOtp("");
  };

  // =====================================================
  // NEW USER
  // =====================================================

  const handleNewUser = () => {
    navigate("/newUserRegister");
  };

  // =====================================================
  // UI
  // =====================================================

  return (
    <div style={styles.page}>
      {/* =================================================
          NORMAL POPUP
      ================================================= */}

      {popup.show && (
        <div
          style={{
            ...styles.popup,

            background: popup.type === "success" ? "#16a34a" : "#dc2626",
          }}
        >
          {popup.type === "success" ? "✓ " : "⚠ "}

          {popup.message}
        </div>
      )}

      {/* =================================================
          OTP POPUP
      ================================================= */}

      {otpPopup && (
        <div style={styles.modalOverlay}>
          <div style={styles.otpModal}>
            {/* OTP ICON */}

            <div style={styles.otpIcon}>🔐</div>

            {/* TITLE */}

            <h2 style={styles.otpTitle}>Verify OTP</h2>

            {/* DESCRIPTION */}

            <p style={styles.otpSubtitle}>
              A 6-digit OTP has been sent to your registered mobile number.
            </p>

            {/* MOBILE */}

            {loginUser?.contactNo && (
              <p style={styles.sentInfo}>
                📱 OTP sent to <strong>+91 {loginUser.contactNo}</strong>
              </p>
            )}

            {/* OTP INPUT */}

            <div style={styles.otpField}>
              <label style={styles.otpLabel}>Enter OTP</label>

              <input
                type="text"
                value={otp}
                onChange={handleOtpChange}
                placeholder="Enter 6 digit OTP"
                maxLength={6}
                inputMode="numeric"
                autoComplete="one-time-code"
                autoFocus
                style={styles.otpInput}
              />
            </div>

            {/* OTP HINT */}

            {otp.length > 0 && otp.length !== 6 && (
              <p style={styles.otpHint}>Please enter all 6 digits.</p>
            )}

            {/* VERIFY BUTTON */}

            <button
              type="button"
              onClick={handleVerifyOtp}
              disabled={otpLoading || otp.length !== 6}
              style={{
                ...styles.verifyOtpButton,

                ...(otpLoading || otp.length !== 6
                  ? styles.disabledButton
                  : {}),
              }}
            >
              {otpLoading ? "Verifying..." : "Verify OTP"}
            </button>

            {/* CANCEL */}

            <button
              type="button"
              onClick={closeOtpPopup}
              disabled={otpLoading}
              style={styles.cancelOtpButton}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* =================================================
          LOGIN CARD
      ================================================= */}

      <div style={styles.loginCard}>
        {/* ICON */}

        <div style={styles.icon}>👤</div>

        {/* TITLE */}

        <h1 style={styles.title}>User Login</h1>

        <p style={styles.subtitle}>Login using your registered mobile number</p>

        {/* FORM */}

        <form onSubmit={handleLogin}>
          {/* MOBILE */}

          <div style={styles.fieldContainer}>
            <label style={styles.label}>Mobile Number</label>

            <div style={styles.mobileContainer}>
              <span style={styles.countryCode}>+91</span>

              <input
                type="text"
                value={contactNo}
                onChange={handleMobileChange}
                placeholder="Enter mobile number"
                maxLength={10}
                inputMode="numeric"
                autoComplete="tel"
                style={styles.mobileInput}
              />
            </div>

            {error && <p style={styles.error}>{error}</p>}
          </div>

          {/* LOGIN BUTTON */}

          <button
            type="submit"
            disabled={loading}
            style={{
              ...styles.loginButton,

              ...(loading ? styles.loginButtonDisabled : {}),
            }}
          >
            {loading ? "Sending OTP..." : "Login"}
          </button>
        </form>

        {/* DIVIDER */}

        <div style={styles.divider}>
          <span style={styles.dividerLine}></span>

          <span style={styles.orText}>OR</span>

          <span style={styles.dividerLine}></span>
        </div>

        {/* NEW USER */}

        <div style={styles.registerSection}>
          <span style={styles.registerText}>New User?</span>

          <button
            type="button"
            onClick={handleNewUser}
            style={styles.registerButton}
          >
            Create New User
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserLogin;

// =====================================================
// STYLES
// =====================================================

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    boxSizing: "border-box",
    background: "linear-gradient(135deg,#eff6ff,#f8fafc,#e0f2fe)",
    fontFamily: "Segoe UI, Arial, sans-serif",
  },

  loginCard: {
    width: "100%",
    maxWidth: "430px",
    background: "#ffffff",
    padding: "40px",
    borderRadius: "24px",
    boxSizing: "border-box",
    boxShadow: "0 20px 60px rgba(15,23,42,.15)",
  },

  icon: {
    width: "80px",
    height: "80px",
    margin: "0 auto 20px",
    borderRadius: "50%",
    background: "#dbeafe",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "38px",
  },

  title: {
    margin: 0,
    textAlign: "center",
    color: "#0f172a",
    fontSize: "32px",
    fontWeight: "800",
  },

  subtitle: {
    textAlign: "center",
    color: "#64748b",
    fontSize: "14px",
    lineHeight: "22px",
    margin: "10px 0 30px",
  },

  fieldContainer: {
    width: "100%",
  },

  label: {
    display: "block",
    marginBottom: "9px",
    color: "#1e293b",
    fontSize: "14px",
    fontWeight: "700",
  },

  mobileContainer: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    border: "1px solid #cbd5e1",
    borderRadius: "12px",
    background: "#ffffff",
    overflow: "hidden",
    boxSizing: "border-box",
  },

  countryCode: {
    padding: "14px 12px",
    background: "#f1f5f9",
    color: "#334155",
    fontSize: "15px",
    fontWeight: "700",
    borderRight: "1px solid #cbd5e1",
  },

  mobileInput: {
    flex: 1,
    minWidth: 0,
    border: "none",
    outline: "none",
    padding: "14px 12px",
    fontSize: "16px",
    color: "#0f172a",
    boxSizing: "border-box",
  },

  error: {
    margin: "8px 0 0",
    color: "#dc2626",
    fontSize: "13px",
    fontWeight: "600",
  },

  loginButton: {
    width: "100%",
    marginTop: "25px",
    padding: "15px",
    border: "none",
    borderRadius: "12px",
    background: "linear-gradient(135deg,#2563eb,#1d4ed8)",
    color: "#ffffff",
    fontSize: "17px",
    fontWeight: "700",
    cursor: "pointer",
    boxShadow: "0 10px 25px rgba(37,99,235,.25)",
  },

  loginButtonDisabled: {
    background: "#7fd475",
    cursor: "not-allowed",
    boxShadow: "none",
  },

  divider: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    margin: "28px 0 22px",
  },

  dividerLine: {
    flex: 1,
    height: "1px",
    background: "#e2e8f0",
  },

  orText: {
    color: "#94a3b8",
    fontSize: "12px",
    fontWeight: "700",
  },

  registerSection: {
    textAlign: "center",
    fontSize: "14px",
  },

  registerText: {
    color: "#64748b",
  },

  registerButton: {
    marginLeft: "6px",
    border: "none",
    background: "transparent",
    color: "#2563eb",
    fontSize: "14px",
    fontWeight: "700",
    cursor: "pointer",
  },

  // ===================================================
  // NORMAL POPUP
  // ===================================================

  popup: {
    position: "fixed",
    top: "20px",
    right: "20px",
    padding: "14px 22px",
    borderRadius: "10px",
    color: "#ffffff",
    fontWeight: "700",
    zIndex: 100000,
    boxShadow: "0 10px 25px rgba(0,0,0,.25)",
    maxWidth: "400px",
  },

  // ===================================================
  // OTP OVERLAY
  // ===================================================

  modalOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(57, 36, 143, 0.65)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 100001,
    padding: "20px",
    boxSizing: "border-box",
  },

  // ===================================================
  // OTP MODAL
  // ===================================================

  otpModal: {
    width: "100%",
    maxWidth: "420px",
    background: "#ffffff",
    borderRadius: "20px",
    padding: "30px",
    boxSizing: "border-box",
    boxShadow: "0 25px 60px rgba(0,0,0,0.25)",
  },

  otpIcon: {
    width: "65px",
    height: "65px",
    margin: "0 auto 15px",
    borderRadius: "50%",
    background: "#dbeafe",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "30px",
  },

  otpTitle: {
    margin: 0,
    textAlign: "center",
    color: "#0f172a",
    fontSize: "25px",
    fontWeight: "800",
  },

  otpSubtitle: {
    margin: "10px 0 15px",
    textAlign: "center",
    color: "#64748b",
    fontSize: "14px",
    lineHeight: "1.5",
  },

  sentInfo: {
    margin: "5px 0",
    textAlign: "center",
    color: "#475569",
    fontSize: "13px",
  },

  otpField: {
    marginTop: "22px",
  },

  otpLabel: {
    display: "block",
    marginBottom: "8px",
    color: "#1e293b",
    fontSize: "14px",
    fontWeight: "700",
  },

  otpInput: {
    width: "100%",
    height: "55px",
    padding: "0 15px",
    border: "1px solid #5b62ed4a",
    borderRadius: "10px",
    outline: "none",
    fontSize: "24px",
    fontWeight: "700",
    letterSpacing: "8px",
    textAlign: "center",
    boxSizing: "border-box",
    color: "#0f172a",
  },

  otpHint: {
    margin: "8px 0 0",
    textAlign: "center",
    color: "#dc2626",
    fontSize: "12px",
    fontWeight: "600",
  },

  verifyOtpButton: {
    width: "100%",
    height: "50px",
    border: "none",
    borderRadius: "10px",
    background: "linear-gradient(135deg,#2563eb,#1d4ed8)",
    color: "#ffffff",
    fontSize: "16px",
    fontWeight: "700",
    cursor: "pointer",
    marginTop: "25px",
    boxShadow: "0 8px 20px rgba(37,99,235,0.20)",
  },

  cancelOtpButton: {
    width: "100%",
    height: "45px",
    border: "none",
    background: "transparent",
    color: "#64748b",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    marginTop: "8px",
  },

  disabledButton: {
    background: "#94a3b8",
    cursor: "not-allowed",
    boxShadow: "none",
  },
};
